// External
import { Injectable } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Subject, Observable } from 'rxjs';

// Internal
import { IToast, IToastExtras, IToastIcon, IToastWithIconOptions } from './iToast.interface';

@Injectable({
    providedIn: 'root'
})

export class ToastService {

    private keepAfterRouteChange = false;
    private subject = new Subject<IToast>();

    constructor(private router: Router) {
        router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                if (this.keepAfterRouteChange) {
                    this.keepAfterRouteChange = false;
                } else {
                    this.clear();
                }
            }
        });
    }

    getToast(): Observable<IToast> {
        return this.subject.asObservable();
    }

    success(message, duration = 3000, keepAfterRouteChange = true): void {
        this.toast(message, keepAfterRouteChange, 'success', duration);
    }

    succesWithIcon(
        message: string,
        icon: IToastIcon,
        options: IToastWithIconOptions = {}
    ): void {
        const {
            duration = 3000,
            keepAfterRouteChange = true,
            actionLabel,
            action,
            onClose
        } = options;
        this.toast(message, keepAfterRouteChange, 'succeswithIcon', duration, false, {
            icon,
            actionLabel,
            action,
            onClose
        });
    }

    error(message, duration = -1, keepAfterRouteChange = true): void {
        this.toast(message, keepAfterRouteChange, 'error', duration);
    }

    info(message: string, duration = 3000, keepAfterRouteChange = true): void {
        this.toast(message, keepAfterRouteChange, 'info', duration);
    }

    warn(message: string, duration = 3000, keepAfterRouteChange = true): void {
        this.toast(message, keepAfterRouteChange, 'warning', duration);
    }

    toast(
        message: string,
        keepAfterRouteChange = true,
        state = 'default',
        duration = 3000,
        dismissable = true,
        extras: IToastExtras = {}
    ): void {
        this.keepAfterRouteChange = keepAfterRouteChange;
        this.subject.next(<IToast>{
            message: message,
            state: state,
            dismissable: dismissable,
            duration: duration,
            icon: extras.icon,
            actionLabel: extras.actionLabel,
            action: extras.action,
            onClose: extras.onClose
        });
    }

    clear() {
        this.subject.next(undefined);
    }
}
